// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--2e5fe";
export var bannerImage = "index-module--banner-image--6c9e5";
export var body = "index-module--body--22d6a";
export var container = "index-module--container--e4153";
export var donateForm = "index-module--donate-form--8e02f";
export var donateSection = "index-module--donate-section--0ba51";
export var section = "index-module--section--f9d02";
export var sectionDonate = "index-module--section-donate--0b8ae";
export var sectionEven = "index-module--section-even--f5916";
export var sectionImage = "index-module--section-image--ad18e";
export var sectionText = "index-module--section-text--035a0";
export var title = "index-module--title--3d9de";